module.exports = __webpack_public_path__ + "img/information-circle-yellow.f38b09bc.svg";